
import { Invoice } from "@/types/payments";
import { supabase } from "@/integrations/supabase/client";
import { handleError } from '@/utils/handleError';

export class ApprovalApiClient {
  async getUnapprovedInvoices(): Promise<Invoice[]> {
    console.log("ApprovalApiClient: Calling approval-api for unapproved invoices");
    const { data, error } = await supabase.functions.invoke("approval-api", {
      body: { action: "getUnapprovedInvoices" },
    });
    
    if (error) {
      throw new Error(error.message || "Failed to fetch unapproved invoices");
    }
    
    if (!data || !data.invoices) {
      console.warn("No invoices data returned from approval-api");
      return [];
    }
    
    console.log(`ApprovalApiClient: Received ${data.invoices.length} unapproved invoices`);
    return data.invoices;
  }

  async getApprovedInvoices(): Promise<Invoice[]> {
    console.log("ApprovalApiClient: Calling approval-api for approved invoices");
    const { data, error } = await supabase.functions.invoke("approval-api", {
      body: { action: "getApprovedInvoices" },
    });
    
    if (error) {
      throw new Error(error.message || "Failed to fetch approved invoices");
    }
    
    if (!data || !data.invoices) {
      console.warn("No invoices data returned from approval-api");
      return [];
    }
    
    console.log(`ApprovalApiClient: Received ${data.invoices.length} approved invoices`);
    return data.invoices;
  }

  async approveInvoice(invoiceId: string, userId: string): Promise<{ success: boolean; invoice?: Invoice }> {
    console.log(`ApprovalApiClient: Calling approval-api to approve invoice ${invoiceId}`);
    const { data, error } = await supabase.functions.invoke("approval-api", {
      body: { action: "approveInvoice", invoiceId },
    });
    
    if (error) {
      throw new Error(error.message || "Failed to approve invoice");
    }
    
    console.log("ApprovalApiClient: Invoice approval response:", data);
    return data;
  }
}
